export const REGIONS = ['americas', 'apac', 'emea', 'global_affinity'];
export const REGION_LABELS = {
    americas: 'Americas',
    apac: 'APAC',
    emea: 'EMEA',
    global_affinity: 'Global Affinity',
};
export const COUNTRY_TO_REGION = {
    US: 'americas', CA: 'americas', MX: 'americas',
    BZ: 'americas', CR: 'americas', SV: 'americas', GT: 'americas', HN: 'americas', NI: 'americas', PA: 'americas',
    AG: 'americas', AI: 'americas', AW: 'americas', BB: 'americas', BL: 'americas', BM: 'americas', BQ: 'americas',
    BS: 'americas', CU: 'americas', CW: 'americas', DM: 'americas', DO: 'americas', GD: 'americas', GP: 'americas',
    HT: 'americas', JM: 'americas', KN: 'americas', KY: 'americas', LC: 'americas', MF: 'americas', MQ: 'americas',
    MS: 'americas', PR: 'americas', SX: 'americas', TC: 'americas', TT: 'americas', VC: 'americas', VG: 'americas', VI: 'americas',
    AR: 'americas', BO: 'americas', BR: 'americas', CL: 'americas', CO: 'americas', EC: 'americas', FK: 'americas',
    GF: 'americas', GY: 'americas', PE: 'americas', PY: 'americas', SR: 'americas', UY: 'americas', VE: 'americas',
    GL: 'americas', PM: 'americas', GS: 'americas',
    AD: 'emea', AT: 'emea', BE: 'emea', CH: 'emea', DE: 'emea', ES: 'emea', FR: 'emea', GB: 'emea', GI: 'emea',
    IE: 'emea', IM: 'emea', IT: 'emea', JE: 'emea', GG: 'emea', LI: 'emea', LU: 'emea', MC: 'emea', MT: 'emea',
    NL: 'emea', PT: 'emea', SM: 'emea', VA: 'emea',
    AX: 'emea', DK: 'emea', EE: 'emea', FI: 'emea', FO: 'emea', IS: 'emea', LT: 'emea', LV: 'emea', NO: 'emea',
    SE: 'emea', SJ: 'emea',
    BG: 'emea', BY: 'emea', CZ: 'emea', HU: 'emea', MD: 'emea', PL: 'emea', RO: 'emea', RU: 'emea', SK: 'emea', UA: 'emea',
    AL: 'emea', BA: 'emea', CY: 'emea', GR: 'emea', HR: 'emea', ME: 'emea', MK: 'emea', RS: 'emea', SI: 'emea', XK: 'emea',
    AE: 'emea', AM: 'emea', AZ: 'emea', BH: 'emea', GE: 'emea', IL: 'emea', IQ: 'emea', IR: 'emea', JO: 'emea',
    KW: 'emea', LB: 'emea', OM: 'emea', PS: 'emea', QA: 'emea', SA: 'emea', SY: 'emea', TR: 'emea', YE: 'emea',
    DZ: 'emea', EG: 'emea', EH: 'emea', LY: 'emea', MA: 'emea', SD: 'emea', TN: 'emea',
    AO: 'emea', BF: 'emea', BI: 'emea', BJ: 'emea', BW: 'emea', CD: 'emea', CF: 'emea', CG: 'emea', CI: 'emea',
    CM: 'emea', CV: 'emea', DJ: 'emea', ER: 'emea', ET: 'emea', GA: 'emea', GH: 'emea', GM: 'emea', GN: 'emea',
    GQ: 'emea', GW: 'emea', KE: 'emea', KM: 'emea', LR: 'emea', LS: 'emea', MG: 'emea', ML: 'emea', MR: 'emea',
    MU: 'emea', MW: 'emea', MZ: 'emea', NA: 'emea', NE: 'emea', NG: 'emea', RE: 'emea', RW: 'emea', SC: 'emea',
    SH: 'emea', SL: 'emea', SN: 'emea', SO: 'emea', SS: 'emea', ST: 'emea', SZ: 'emea', TD: 'emea', TG: 'emea',
    TZ: 'emea', UG: 'emea', YT: 'emea', ZA: 'emea', ZM: 'emea', ZW: 'emea',
    CN: 'apac', HK: 'apac', JP: 'apac', KP: 'apac', KR: 'apac', MN: 'apac', MO: 'apac', TW: 'apac',
    BN: 'apac', ID: 'apac', KH: 'apac', LA: 'apac', MM: 'apac', MY: 'apac', PH: 'apac', SG: 'apac', TH: 'apac', TL: 'apac', VN: 'apac',
    AF: 'apac', BD: 'apac', BT: 'apac', IN: 'apac', LK: 'apac', MV: 'apac', NP: 'apac', PK: 'apac',
    KG: 'apac', KZ: 'apac', TJ: 'apac', TM: 'apac', UZ: 'apac',
    AS: 'apac', AU: 'apac', CK: 'apac', FJ: 'apac', FM: 'apac', GU: 'apac', KI: 'apac', MH: 'apac', MP: 'apac',
    NC: 'apac', NF: 'apac', NR: 'apac', NU: 'apac', NZ: 'apac', PF: 'apac', PG: 'apac', PN: 'apac', PW: 'apac',
    SB: 'apac', TK: 'apac', TO: 'apac', TV: 'apac', VU: 'apac', WF: 'apac', WS: 'apac',
    CC: 'apac', CX: 'apac', IO: 'apac',
};
export function regionForCountry(countryCode) {
    if (!countryCode)
        return 'global_affinity';
    return COUNTRY_TO_REGION[countryCode.toUpperCase()] ?? 'global_affinity';
}
// Inverse of COUNTRY_TO_REGION — every region maps to its country list.
// Used at the SQL layer to translate a region filter into an `IN (...)`
// predicate over `country_code`, now that the materialized `region`
// column is gone (see migration 0031).
export const COUNTRIES_BY_REGION = (() => {
    const out = {
        americas: [],
        apac: [],
        emea: [],
    };
    for (const [code, region] of Object.entries(COUNTRY_TO_REGION)) {
        out[region].push(code);
    }
    return out;
})();
export const ALL_MAPPED_COUNTRY_CODES = Object.keys(COUNTRY_TO_REGION);
// Continents, distinct from the coarse business `Region` above: `emea` fuses
// Europe + the Middle East + Africa and `apac` fuses Asia + Oceania, so a
// region cannot answer "Europe vs Africa" or "Asia vs Oceania". This map is
// the finer split the member-location filter needs, derived from the same
// ISO-3166 alpha-2 country set. Transcontinental codes follow the sub-groupings
// already annotated in `COUNTRY_TO_REGION` (e.g. Cyprus sits with Southern
// Europe there, the Caucasus and Turkey with the Middle East → Asia).
export const CONTINENTS = ['africa', 'americas', 'asia', 'europe', 'oceania'];
export const COUNTRY_TO_CONTINENT = {
    // Americas — North, Central, Caribbean, South, and northern outliers.
    US: 'americas', CA: 'americas', MX: 'americas',
    BZ: 'americas', CR: 'americas', SV: 'americas', GT: 'americas', HN: 'americas', NI: 'americas', PA: 'americas',
    AG: 'americas', AI: 'americas', AW: 'americas', BB: 'americas', BL: 'americas', BM: 'americas', BQ: 'americas',
    BS: 'americas', CU: 'americas', CW: 'americas', DM: 'americas', DO: 'americas', GD: 'americas', GP: 'americas',
    HT: 'americas', JM: 'americas', KN: 'americas', KY: 'americas', LC: 'americas', MF: 'americas', MQ: 'americas',
    MS: 'americas', PR: 'americas', SX: 'americas', TC: 'americas', TT: 'americas', VC: 'americas', VG: 'americas', VI: 'americas',
    AR: 'americas', BO: 'americas', BR: 'americas', CL: 'americas', CO: 'americas', EC: 'americas', FK: 'americas',
    GF: 'americas', GY: 'americas', PE: 'americas', PY: 'americas', SR: 'americas', UY: 'americas', VE: 'americas',
    GL: 'americas', PM: 'americas', GS: 'americas',
    // Europe — Western/Southern, Nordics, Eastern Europe, Balkans (incl. Cyprus).
    AD: 'europe', AT: 'europe', BE: 'europe', CH: 'europe', DE: 'europe', ES: 'europe', FR: 'europe', GB: 'europe', GI: 'europe',
    IE: 'europe', IM: 'europe', IT: 'europe', JE: 'europe', GG: 'europe', LI: 'europe', LU: 'europe', MC: 'europe', MT: 'europe',
    NL: 'europe', PT: 'europe', SM: 'europe', VA: 'europe',
    AX: 'europe', DK: 'europe', EE: 'europe', FI: 'europe', FO: 'europe', IS: 'europe', LT: 'europe', LV: 'europe', NO: 'europe',
    SE: 'europe', SJ: 'europe',
    BG: 'europe', BY: 'europe', CZ: 'europe', HU: 'europe', MD: 'europe', PL: 'europe', RO: 'europe', RU: 'europe', SK: 'europe', UA: 'europe',
    AL: 'europe', BA: 'europe', CY: 'europe', GR: 'europe', HR: 'europe', ME: 'europe', MK: 'europe', RS: 'europe', SI: 'europe', XK: 'europe',
    // Asia — Middle East (incl. Caucasus & Turkey), East, Southeast, South, Central.
    AE: 'asia', AM: 'asia', AZ: 'asia', BH: 'asia', GE: 'asia', IL: 'asia', IQ: 'asia', IR: 'asia', JO: 'asia',
    KW: 'asia', LB: 'asia', OM: 'asia', PS: 'asia', QA: 'asia', SA: 'asia', SY: 'asia', TR: 'asia', YE: 'asia',
    DZ: 'africa', EG: 'africa', EH: 'africa', LY: 'africa', MA: 'africa', SD: 'africa', TN: 'africa',
    // Sub-Saharan Africa.
    AO: 'africa', BF: 'africa', BI: 'africa', BJ: 'africa', BW: 'africa', CD: 'africa', CF: 'africa', CG: 'africa', CI: 'africa',
    CM: 'africa', CV: 'africa', DJ: 'africa', ER: 'africa', ET: 'africa', GA: 'africa', GH: 'africa', GM: 'africa', GN: 'africa',
    GQ: 'africa', GW: 'africa', KE: 'africa', KM: 'africa', LR: 'africa', LS: 'africa', MG: 'africa', ML: 'africa', MR: 'africa',
    MU: 'africa', MW: 'africa', MZ: 'africa', NA: 'africa', NE: 'africa', NG: 'africa', RE: 'africa', RW: 'africa', SC: 'africa',
    SH: 'africa', SL: 'africa', SN: 'africa', SO: 'africa', SS: 'africa', ST: 'africa', SZ: 'africa', TD: 'africa', TG: 'africa',
    TZ: 'africa', UG: 'africa', YT: 'africa', ZA: 'africa', ZM: 'africa', ZW: 'africa',
    // Asia — East, Southeast, South, Central, plus the British Indian Ocean Territory.
    CN: 'asia', HK: 'asia', JP: 'asia', KP: 'asia', KR: 'asia', MN: 'asia', MO: 'asia', TW: 'asia',
    BN: 'asia', ID: 'asia', KH: 'asia', LA: 'asia', MM: 'asia', MY: 'asia', PH: 'asia', SG: 'asia', TH: 'asia', TL: 'asia', VN: 'asia',
    AF: 'asia', BD: 'asia', BT: 'asia', IN: 'asia', LK: 'asia', MV: 'asia', NP: 'asia', PK: 'asia',
    KG: 'asia', KZ: 'asia', TJ: 'asia', TM: 'asia', UZ: 'asia',
    IO: 'asia',
    // Oceania — Australasia and the Pacific, plus Australia's Indian Ocean isles.
    AS: 'oceania', AU: 'oceania', CK: 'oceania', FJ: 'oceania', FM: 'oceania', GU: 'oceania', KI: 'oceania', MH: 'oceania', MP: 'oceania',
    NC: 'oceania', NF: 'oceania', NR: 'oceania', NU: 'oceania', NZ: 'oceania', PF: 'oceania', PG: 'oceania', PN: 'oceania', PW: 'oceania',
    SB: 'oceania', TK: 'oceania', TO: 'oceania', TV: 'oceania', VU: 'oceania', WF: 'oceania', WS: 'oceania',
    CC: 'oceania', CX: 'oceania',
};
export function continentForCountry(countryCode) {
    if (!countryCode)
        return null;
    return COUNTRY_TO_CONTINENT[countryCode.toUpperCase()] ?? null;
}
//# sourceMappingURL=region.js.map